/**
 * Extracts article references (e.g. "L5122-6") from a legalBasis string
 * and makes them clickable — scrolling to the matching source.
 * Extrait tel quel de ResultsDisplay.tsx.
 */
export default function LegalRef({ text, colorClass, onRefClick }: { text: string; colorClass: string; onRefClick: (ref: string) => void }) {
  // Match patterns like L5122-6, L5122-8, R5122-3, R5122-4, D5121-1
  const parts = text.split(/((?:Article\s+)?[LRD]\d{4}-\d+(?:-\d+)?)/gi);

  return (
    <p className={`text-xs ${colorClass} mt-2`}>
      Ref:{' '}
      {parts.map((part, i) => {
        // Check if this part is an article reference
        const refMatch = part.match(/[LRD]\d{4}-\d+(?:-\d+)?/i);
        if (refMatch) {
          return (
            <button
              key={i}
              onClick={() => onRefClick(refMatch[0])}
              className="underline decoration-dotted underline-offset-2 hover:decoration-solid cursor-pointer transition-colors hover:text-violet-600"
            >
              {part}
            </button>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </p>
  );
}
